import { connect } from 'react-redux';
import { onChangePassword, onChangeUserData } from '../../reducers/auth.reducers';
import Profile from './profile';

const mapDispatchToProps = dispatch => ({
  changePassword: changePasswordDto => dispatch(onChangePassword(changePasswordDto)),
  updateUserData: userDto => dispatch(onChangeUserData(userDto)),
});

const mapStateToProps = state => ({
  user: state.authentication.user,
  errorMessage: state.authentication.errorMessage,
  config: state.authentication.config,
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/app/main/profile/profile.container.js